/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemDateRange } from './formPagePropertyItemDateRange';
import { FormPagePropertyItemDateInputLimit } from './formPagePropertyItemDateInputLimit';
import { FormPagePropertyItemDateErrorMessage } from './formPagePropertyItemDateErrorMessage';
import { FormPagePropertyItemDateInputFormat } from './formPagePropertyItemDateInputFormat';


export interface FormPagePropertyItemDateAllOf { 
    type: FormPagePropertyItemDateAllOf.TypeEnum;
    format: FormPagePropertyItemDateAllOf.FormatEnum;
    dateRange?: FormPagePropertyItemDateRange;
    inputLimit: FormPagePropertyItemDateInputLimit;
    inputFormat: FormPagePropertyItemDateInputFormat;
    errorMessage?: FormPagePropertyItemDateErrorMessage;
}
export namespace FormPagePropertyItemDateAllOf {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
    export type FormatEnum = 'date';
    export const FormatEnum = {
        Date: 'date' as FormatEnum
    };
}



